exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._3yRowVYrb7ShOzPix5egWF{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 25px\n}\n\n._GetICkDVYDMmyq5eZGym{\n  flex: 1;\n  margin: 0px;\n}", "", {"version":3,"sources":["/home/forge/qa.leadpm.io/frontend/src/Screens/ItemDescriptions/Components/Header/Component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;CACpB;;AAED;EACE,QAAQ;EACR,YAAY;CACb","file":"Component.css","sourcesContent":[".stack{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 25px\n}\n\n.heading{\n  flex: 1;\n  margin: 0px;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"stack": "_3yRowVYrb7ShOzPix5egWF",
	"heading": "_GetICkDVYDMmyq5eZGym"
};